import { NgModule } from '@angular/core';
import { ValidationContainerComponent } from './validation-container.component';
import { ValidationService } from './validation.service';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [],
  imports: [CommonModule, MaterialModule, ValidationContainerComponent, MatIconModule],
  providers: [ValidationService],
  exports: [ValidationContainerComponent],
})
export class ValidationModule {}
